import router, {loginPageUrl} from "../../router";
import adMasterApi from "../../api/adMasterApi";
import gatewayApi from "../../api/gatewayApi";
import authzApi from "../../api/authzApi";
import {MEMBERTYPE_MASTER, MEMBERTYPE_MEMBER} from "@/constants";

const localStorageAuthKey = 'auth';
const localStorageUserKey = 'user';
const lastSelectedAdAccount = 'lastadaccount';

/***
 * 권한이 필요한 페이지 중에서 AdAccount가 없는 카카오 계정이 이동할 수 있는 것들.
 */
const defaultMenus = [
  {
    "upperId": 0,
    "name": "내 정보 관리",
    "systemType": "GAP",
    "url": "/user",
    "authLevel": 0,
    "lowerMenuList": [{
      "name": "내 정보",
      "systemType": "GAP",
      "url": "/user/inforamtion",
      "authLevel": 0,
      "lowerMenuList": [{
        "name": "개인정보 설정",
        "systemType": "GAP",
        "url": "/user/management/admin-account",
        "authLevel": 10,
        "lowerMenuList": []
      }]
    }, {
      "name": "내 광고계정",
      "systemType": "GAP",
      "url": "/user/ad-account",
      "authLevel": 0,
      "lowerMenuList": [{
        "name": "내 광고계정 관리",
        "systemType": "GAP",
        "url": "/user/management/ad-account",
        "authLevel": 10,
        "lowerMenuList": []
      }]
    }],
  },
  {
    "upperId": 0,
    "name": "대시보드",
    "systemType": "GAP",
    "url": "/",
    "authLevel": 0,
    "lowerMenuList": [{
      "name": "대시보드",
      "systemType": "GAP",
      "url": "/",
      "authLevel": 0,
      "lowerMenuList": [{
        "name": "대시보드",
        "systemType": "GAP",
        "url": "/",
        "authLevel": 10,
        "lowerMenuList": []
      }]
    }]
  }
];

export default {
  state: {
    auth: null, //Gateway에서 가져오는 auth 정보
    user: null, //Authz에서 가져오는 유저 정보
    menuTree: [],
    adAccountList: [],
    ldapAdAccountList: [], // LDAP계정을 위한 Member Type까지 포함된 리스트
    selectedAdAccountId: null,
    currentRoute: null
  },
  getters: {
    getCurrentMenu(state, getters) {
      let menu = null;
      const path = state.currentRoute.path;
      const menuPath = state.currentRoute.meta.menuPath;
      getters.getMenus.forEach(oneDepthMenu => oneDepthMenu.lowerMenuList.forEach(
        twoDepthMenu => twoDepthMenu.lowerMenuList.forEach(
          threeDepthMenu => {
            if (threeDepthMenu.url === path ||
                threeDepthMenu.url === menuPath) {
              menu = threeDepthMenu;
            }
          }
        )));
      return menu;
    },
    hasAuth(state, getters) {
      return !!getters.getAuth;
    },
    getAuth(state) {
      if (state.auth) {
        return state.auth;
      }
      const storedAuth = JSON.parse(localStorage.getItem(localStorageAuthKey));
      if (storedAuth) {
        state.auth = storedAuth;
        return storedAuth;
      }
      localStorage.removeItem(localStorageAuthKey);
      return null;
    },
    getAuthType(state, getters) {
      if (!getters.hasAuth) {
        return null;
      }
      let result = getters.getAuth.authType.toLowerCase();
      if (result === 'biz') {
        result = 'kakao';
      }
      return result.toUpperCase();
    },
    getAccountId(state, getters) {
      return getters.getAuth?.accountId;
    },
    /**
     *
     * @return accountId with accountType
     */
    getFullAccountId(state, getters) {
      switch (getters.getAuthType) {
      case "LDAP":
        return getters.getAccountId + "::" + getters.getAuthType;
      case "KAKAO":
        return getters.getKakaoEmail + "::" + getters.getAuthType;
      }
    },
    getKakaoEmail(state, getters) {
      if (getters.getAuthType === "KAKAO") {
        return getters.getAuth.personName;
      }
    },
    getMenus(state) {
      return state.menuTree.length > 0 ? state.menuTree : [];
    },
    getUser(state) {
      return state.user ||
             JSON.parse(localStorage.getItem(localStorageUserKey));
    },
    getAuthLevel(state, getters, actions) {
      let authLevelFromAdAccount = 0;

      if (state.currentRoute.matched.some(elm => elm.meta.authLevelFromAdAccount === true)) {
        if (!getters.selectedAdAccount) {
          authLevelFromAdAccount = 0;
        } else {
          const memberTypeMap = {};
          memberTypeMap[MEMBERTYPE_MASTER] = 10;
          memberTypeMap[MEMBERTYPE_MEMBER] = 0;

          if (getters.selectedAdAccount.masterAdminUserId === getters.getFullAccountId) { //LDAP의 AdAccount 조회 에는 memberType이 안내려오기 때문에 보정해줌
            getters.selectedAdAccount.memberType = MEMBERTYPE_MASTER;
          }

          authLevelFromAdAccount = memberTypeMap[getters.selectedAdAccount.memberType || MEMBERTYPE_MEMBER];
        }
      }

      const authLevelFromMenu = getters.getCurrentMenu?.authLevel || 0;

      return Math.max(authLevelFromAdAccount, authLevelFromMenu);

    },
    isMaster(state, getters) {
      return getters.getAuthLevel === 10;
    },
    isSignedUp(state, getters) {
      return !!getters.getUser;
    },
    selectedAdAccount(state) {
      if (!state.selectedAdAccountId) {
        state.selectedAdAccountId = Number.parseInt(localStorage.getItem(lastSelectedAdAccount));
      }
      return state.ldapAdAccountList?.find(elm => elm.id === state.selectedAdAccountId) ||
             state.adAccountList.find(elm => elm.id === state.selectedAdAccountId);
    },

    getAdAccountList(state) {
      return state.adAccountList;
    },

    getLdapAdAccountList(state) {
      return state.ldapAdAccountList;
    },

    getMenuByPath: (state, getters) => (path, menuPath = undefined) => {
      return getters.getThreeDepthMenus
        .find(elm => elm.url === path ||
                     (!!menuPath && elm.url === menuPath));
    },

    getThreeDepthMenus(state, getters) {
      return getters.getMenus
        .flatMap(oneDepthMenu => oneDepthMenu.lowerMenuList
          .flatMap(twoDepthMenu => twoDepthMenu.lowerMenuList));
    },

    getFirstMenu(state, getters) {
      // 첫번째 메뉴 반환
      return getters.getThreeDepthMenus.length > 0 ?
             getters.getThreeDepthMenus[0] :
             null;
    },
  },
  mutations: {
    setCurrentRoute(state, currentRoute) {
      state.currentRoute = currentRoute;
    },
    setAuth(state, auth) {
      state.auth = auth;
      localStorage.setItem(localStorageAuthKey, JSON.stringify(auth));
    },
    setMenuTree(state, menuTree) {
      state.menuTree = menuTree;
    },
    setUser(state, user) {
      if (user == null) {
        localStorage.removeItem(localStorageUserKey)
      } else {
        user.id = user.idpId + "::" + user.idpType;
        state.user = user;
        localStorage.setItem(localStorageUserKey, JSON.stringify(user));
      }
    },
    removeAuth(state) {
      const authType = state?.auth?.authType?.toUpperCase();
      state.auth = null;
      state.user = null;
      localStorage.removeItem(localStorageAuthKey);
      localStorage.removeItem(localStorageUserKey);
      if (!alert(null)) {
        router.push(loginPageUrl);
      } else {
        alert().then(() => router.push(loginPageUrl));
      }
    },
    selectAdAccount(state, id) {
      state.selectedAdAccountId = id;
      if (id === null || id === undefined) {
        localStorage.removeItem(lastSelectedAdAccount);
      } else {
        localStorage.setItem(lastSelectedAdAccount, id);
      }
    },
    setAdAccountList(state, adAccountList) {
      const detailList = state.adAccountList.filter(adAccount => adAccount.detail);
      state.adAccountList =
        adAccountList.map(
          elm => detailList.find(detailAdAccount => detailAdAccount.id === elm.id) || elm);
    },
    setAdAccount(state, adAccount) {
      if (adAccount == null) {
        return;
      }
      const ldapIndex = state.ldapAdAccountList.findIndex(elm => elm.id === adAccount.id);
      if (ldapIndex >= 0) {
        state.ldapAdAccountList.splice(ldapIndex, 1, {...adAccount, detail: true});
      }
      const index = state.adAccountList.findIndex(elm => elm.id === adAccount.id);

      state.adAccountList.splice(index, 1, {
        ...adAccount,
        detail: true
      });
    }
  },
  actions: {
    async refreshAdAccountList(context) {
      if (!context.getters.getAuth) {
        return;
      }
      if (context.getters.getAuthType === "KAKAO") {
        await gatewayApi.refresh().catch(
          (error) => {
            if (router.currentRoute.path !== '/' &&
                router.currentRoute.path !== '/login') {
              alert("로그인 쿠키가 만료 되었거나 갱신에 문제가 있습니다. 다시 로그인해주세요.").then(() => {
                context.dispatch('logout');
              });
            } else {
              context.dispatch('logout');
            }
          }
        );
        if (!context.getters.getUser) {
          return [];
        }
        const response = (await adMasterApi.getAdAccountsByUserId(context.getters.getUser.id));
        if (response && response.data && response.data.data) {
          context.commit('setAdAccountList', response.data.data);
          return response;
        }
      } else {
        let response = (await adMasterApi.getAdAccountsByUserId(context.getters.getUser.idpId));
        context.state.ldapAdAccountList = response?.data?.data || [];
        response = (await adMasterApi.getAdAccounts());
        if (response && response.data && response.data.data) {
          context.commit('setAdAccountList', response.data.data);
          return response;
        }
      }
      //AdAccount 목록 불러오기에 실패했으면 로그아웃 시킨다.
      context.dispatch('logout');
    },

    async getAllAdAccountsDetails(context) {
      await Promise.all(
        context.getters.getAdAccountList.map(async adAccount => {
          if (!adAccount.detail) {
            await context.dispatch("getAdAccountDetail", adAccount.id);
          } else {
            return true;
          }
        }));
    },

    async getAdAccountDetail(context, adAccountId) {
      let result = null;
      const adAccount = context.getters.getAdAccountList.find(elm => elm.id === adAccountId);
      if (adAccount?.detail === true) {
        result = adAccount;
      } else {
        await adMasterApi.getAdAccount(adAccountId).then(
          response => {
            result = response?.data?.data;

          }
        );
      }

      context.commit("setAdAccount", result);

      return result;
    },

    async refreshAdminMenu(context) {
      if (!context.getters.getAuth) {
        return;
      }

      let menuList = [];

      if (context.getters.getAuthType === "LDAP") {
        const response = await authzApi.getMenuList(context.getters.getAccountId);
        if (response && response.data && response.data.data) {
          menuList = response.data?.data?.authMenusBySystemMap?.GAP || [];
        }
      } else {
        if (!context.getters.selectedAdAccount) {
          await context.dispatch("refreshAdAccountList");
        }
        if (context.getters.selectedAdAccount) {
          const response = await authzApi.getAuthMenus(context.getters.selectedAdAccount.id).catch(
            () => {
              context.commit("selectAdAccount", null);
            });
          if (response?.status === 200) {
            menuList = response.data?.data?.authMenusBySystemMap?.GAP || [];
          }
        }
      }

      menuList = menuList || [];

      const makeMenuTree = function (upperMenu, depth) {
        let foundLowerMenuList = menuList.filter(elm => elm.upperId === upperMenu.id);
        for (const lowerMenu of foundLowerMenuList) {
          makeMenuTree(lowerMenu, depth + 1);
        }
        if (depth < 3) {
          foundLowerMenuList =
            foundLowerMenuList.filter(elm => elm.lowerMenuList.length > 0);
        }
        upperMenu.lowerMenuList = foundLowerMenuList;
        foundLowerMenuList.forEach(elm => {
          elm.upperMenu = upperMenu;
        });
        return upperMenu;
      };

      const menuTreeRoot = makeMenuTree({id: 0}, 1);
      const menuTree =
        menuTreeRoot ? menuTreeRoot.lowerMenuList : [];

      // 카카오 계정에 기본 메뉴가 없으면 추가해준다.
      if (context.getters.getAuthType === "KAKAO" && !menuTree.find(elm => elm.url === "/user")) {
        menuTree.push(...defaultMenus);
      }

      context.commit('setMenuTree', menuTree);

    }
    ,
    async getSignedUp(context) {
      let result = false;
      try {
        await context.dispatch('getUserFromAuthz');
        if (context.getters.isSignedUp) {
          result = true;
        }
      } catch (e) {
        //  얻어올때 에러가 나면
        console.log(e);
        result = false;
      }
      return result;
    }
    ,
    async getUserFromAuthz(context, forceRefresh = false) {
      if (!forceRefresh) {
        if (!context.getters.hasAuth) {
          return null;
        }
        if (context.getters.getUser != null) {
          return context.getters.getUser;
        }
      }
      let user = null;
      await authzApi.getUserAtLogin(context.getters.getAuthType === "LDAP" ?
                                    context.getters.getAccountId :
                                    context.getters.getKakaoEmail + "::" +
                                    context.getters.getAuthType, forceRefresh)
        .then((response) => {
          user = response.data?.data?.user;
          if (user?.status === "NORMAL") {
            context.commit('setUser', user);
          } else if (user?.status === "WITHDRAWL") {
            alert('탈퇴한 계정입니다. 다시 가입해주세요.');
            context.commit('setUser', null);
          } else if (user?.status === "DORMANT") {
            alert('30일 이상 로그인하지 않아 계정이 잠금처리 되었습니다. 기획실 아지트에서 다시 권한을 신청해주세요.');
            context.dispatch('logout');
          } else {
            context.commit('setUser', null);
          }
        });
      return user;
    },

    async ldapLogin(context, loginDto) {
      await gatewayApi.ldapLogin(loginDto)
        .then(async (response) => {
          context.commit('setAuth', response.data);
          await context.dispatch('getUserFromAuthz');

          const lastPath = localStorage.getItem('lastVisited');
          if (lastPath) {
            router.push(lastPath);
          } else {
            router.push('/');
          }
        })
        .catch((error) => {
          alert(error.response.data.msg);
        });
    },
    async kakaoLogin(context, accessToken) {
      await gatewayApi.kakaoLogin(accessToken)
        .then(async (response) => {
          context.commit('setAuth', response.data);
          await context.dispatch('getUserFromAuthz');

          const lastPath = localStorage.getItem('lastVisited');
          if (lastPath) {
            router.push(lastPath);
          } else {
            router.push('/');
          }
        })
        .catch((error) => {
          alert(error.response?.data?.msg);
          router.push('/login');
        });
    },
    capriLoginPopup(context) {
      if (Kakao.isInitialized()) {
        Kakao.Auth.loginForm({
                               success: (response) => {
                                 console.log(response);
                                 router.push(
                                   {
                                     name: 'kakaoLogin',
                                     params: {accessToken: response.access_token}
                                   })
                               },
                               fail: (response) => {
                                 console.log("login failed!");
                                 console.error(response);
                               }
                             });
      }
    },
    async logout(context) {
      const logoutFunc =  //Idp Type마다 로그아웃 다르게 처리
        context.getters.getAuthType === "LDAP" ?
        gatewayApi.ldapLogout :
        gatewayApi.kakaoLogout;

      await logoutFunc()
        .then((response) => {
          if (!Kakao.Auth.getAccessToken()) {
          } else {
            Kakao.Auth.logout(function () {
              console.log("Logged out");
              context.commit("removeAuth");
              localStorage.removeItem('lastVisited');
            });
          }
          if (response.status === 200) {
            context.commit("removeAuth");
            localStorage.removeItem('lastVisited');
          }
        }, error => {
          context.commit("removeAuth");
          localStorage.removeItem('lastVisited');
        })
    }
  }
}
